const ValidateForm = (state) => {

    let mailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let phonePattern = /^[0-9]{2,3}(?:-?)[0-9]{3}(?:-?)[0-9]{4}$/;


    if(!state.fullName){
        alert("נדרש למלא שם מלא");
        return false;
    }
    if(!state.phone){
        alert("נדרש למלא מספר טלפון")
        return false;

    }
    if(!state.email){
        alert("נדרש למלא כתובת מייל")
        return false;

    }
    if(state.poalimClient == null){
        alert("נדרש לציין האם אתה לקוח בנק הפועלים");
        return false;
    }
    if(!state.activity){
        alert("נדרש למלא תחום פעילות")
        return false;

    }
    if(!state.bussinessId){
        alert("נדרש למלא ח.פ")
        return false;

    }
    if(!state.description){
        alert("נדרש למלא את תיאור העסק")
        return false;

    }
    if(!state.digitalChoice){
        alert("נדרש לבחור חיזוק דיגיטלי")
        return false;

    }
    // if(!state.tosAgree){
    //     alert("נדרש להסכים לתקנון השימוש")
    //     return false;

    // }
    if(!state.bussinessLocation){
        alert("נדרש לרשום את מיקום העסק");
        return false;
    }
    if(!state.bussinessName){
        alert("נדרש לרשום את שם העסק")
        return false;
    }
    if(!state.privacyAgree){
        alert("נדרש להסכים לתקנון ולמדיניות הפרטיות");
        return false;
    }
    if(!phonePattern.test(state.phone)){
        alert("נדרש לכתוב מספר טלפון תקין")
        return false;
    }
    if(!mailPattern.test(state.email)){
        alert("נדרש לכתוב מייל תקין")
        return false;
    }
    return true;
}
export { ValidateForm }